const oktaConfig = {
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID,
  issuer: import.meta.env.VITE_OKTA_AUTH_SERVER,
  redirectUri: globalThis.location.origin + '/oktalogin',
};

export default oktaConfig;
